import './nav.js'
// import './video'
import '../shared/phone.js'
import '../shared/nav/collapsing_md_nav.js'
// import './platinium'
// import './top_nav'
// import './mobile_partner_nav'
import '../shared/buyers_page_personalizer.js'
import './stripe_styling.js'

import '../shared/h4h_form.js'
import AddToCart from '../full-gpe/cart/add-to-cart.js'
import { store } from'../default/store/index.js'
import 'bootstrap/dist/js/bootstrap.esm.js'
import '../shared/nav/bootstrap_nav.js'

import PhoneNumber from '../shared/phone.js'
import AddToCartForms from '../shared/add_to_cart_forms/index.js'
import HotelIndex from '../shared/add_to_cart_forms/h4h_hotels/hotel_index.vue'
import CartNav from '../shared/nav/nav_cart/index.js'
import Checkout from '../shared/checkout/index.js'
import AbTests from '../shared/ab_tests.js'
import DepositRedemptions from '../shared/deposit_redemptions/index.js'
import PackageTabs from '../shared/package_tabs.js'
// import PricingFilterButtons from './pricing_filter/pricing_filter_buttons'

import VueLoader from '../default/vue-loader.js'
import PriceFilter from '../shared/price_filter'
// import './ticket_seating_chart'
import '../shared/seating_chart_filter.js'
import '../shared/package_comparisons.js'
import '../shared/hide_map.js'
import '../shared/disable_reset.js'
// import './tooltip'

document.addEventListener('turbo:load', () => {
  AddToCartForms.loadBottomForm()
  CartNav.addCartToNavbar()
  DepositRedemptions.findCustomerDeposits()
  Checkout.loadWithAddOn()
  AddToCart.AddToCart()
  AbTests.loadHotelAbTests()

  PackageTabs.loadTabs(782)

  // if (document.getElementById('packge-price-filer')) {
  //   PricingFilterButtons.loadPricingFilters()
  // }

  if(document.getElementById('seating_chart_price')) {
    VueLoader.loadVueComponent(PriceFilter, document.getElementById('seating_chart_price'), store)
  }

  let phoneNumber = PhoneNumber()
  $('.navbar-right').append(`<li class="menu-item phone-contact"><a role="button" href="tel:${phoneNumber}"><div class="original">Questions? Call Us</div></a></li>`)

  VueLoader.loadVueComponent(HotelIndex, document.getElementById('hotelIndex'), store)
})
